import api from '../conf/api'
import backend from '../utils/backend'
export default {
// 隐私政策  服务协议
  getWebSiteSetInfo(type) {
    backend.request(api.getWebSiteSetInfo, {}).then((res) => {
      if (res.code == 200) {
        if (type == 1) {
          var newwindow=window.open();
          newwindow.document.write('<html><title>服务协议</title>');
          newwindow.document.write('<body>');
          newwindow.document.write(res.data.serviceAgreement);
          newwindow.document.write('</body></html>');
        }
        if (type == 2) {
          var newwindow=window.open();
          newwindow.document.write('<html><title>隐私政策</title>');
          newwindow.document.write('<body>');
          newwindow.document.write(res.data.privacyPolicy);
          newwindow.document.write('</body></html>');
        }
      }
    })
  },

  // 手机号隐藏
  phoneHide(data) {
    if(data) {
      return data.slice(0, 3) + '****' + data.slice(7, 11)
    } else {
      return ''
    }
  },

  // 证件号隐藏
  idCardHide(data) {
    if(data) {
      return data.slice(0, 4) + '**********' + data.slice(14, 18)
    } else {
      return ''
    }
  },

}



// WEBPACK FOOTER //
// ./src/utils/publicFun.js